<template>
  <f7-page name="webkamery-detail" @page:init="onPageInit"  @page:beforeout="onPageBeforeOut" @page:beforeremove="onPageBeforeRemove">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>{{ webcamData.name }} - Web kamery</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
        <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <template v-if="isDataLoaded">

      <f7-toolbar bottom>
        <f7-block class="wc-toolbar width-100">
          <f7-row>
            <f7-col width="20" class="wc-time">
            <f7-button class="ec-settings" :disabled="!isImagesLoaded" popover-open=".wc-settings-popover" icon-f7="slider_horizontal_3"></f7-button>
            </f7-col>
            <f7-col width="20" class="wc-time">
              {{ currentItemTime }}
            </f7-col>
            <f7-col width="60">
              <f7-range
                  class="wc-range"
                  ref="wcRangeSlider"
                  :min="1"
                  :max="this.wcCurrentMaxImages"
                  :step="1"
                  :value="this.currentImageIndex"
                  color="blue"
                  @range:change="rangeChanged"
              ></f7-range>
            </f7-col>
          </f7-row>
        </f7-block>
      </f7-toolbar>


      <l-map :options="mapOptions"
             ref="webcamMap"
             @ready="initMap()"
      >
        <l-control-zoom position="bottomright"></l-control-zoom>
        <l-image-overlay
            ref="layerImg"
            :url="imageUrl"
            :bounds="imageBounds"
            :maxBounds="imageBounds"
            :center="[0,0]"
        />
      </l-map>


      <!--f7-block class="margin-top-half no-padding align-items-center">
        <pinch-zoom ref="refZoom" style="position: relative;" limitPan="true" overflow="visible" disableZoomControl="disable" limitZoom="5" backgroundColor="rgba(255,255,255,1)">
          <img :src="imageUrl" class="wc-image position-relative">
        </pinch-zoom>
      </f7-block-->


      <image-preloader
          :srcs="imagesToPreload"
          @loaded-all="imageLoadedAll"
          @loaded="imageLoadedOne"
          @onerror="imagePreloadError"
      />

      <f7-popover class="wc-settings-popover">
        <f7-list>
          <f7-list-item radio radio-icon="start"
                        value="5"
                        :checked="this.wcMaxImages === 5"
                        @change="maxNumChanged"
                        name="num-images"
                        popover-close
                        title="5 snímkov">
          </f7-list-item>
          <f7-list-item radio radio-icon="start"
                        value="10"
                        :checked="this.wcMaxImages === 10"
                        @change="maxNumChanged"
                        name="num-images"
                        popover-close
                        title="10 snímkov">
          </f7-list-item>
          <f7-list-item radio radio-icon="start"
                        value="30"
                        :checked="this.wcMaxImages === 30"
                        @change="maxNumChanged"
                        name="num-images"
                        popover-close
                        title="30 snímkov">
          </f7-list-item>
          <f7-list-item radio radio-icon="start"
                        value="60"
                        :checked="this.wcMaxImages === 60"
                        @change="maxNumChanged"
                        name="num-images"
                        popover-close
                        title="60 snímkov">
          </f7-list-item>
        </f7-list>
      </f7-popover>


    </template>
  </f7-page>
</template>
<script>
import Axios from "axios";
import SHMUconf from "../js/SHMUconf";
import imagePreloader from '../components/imagePreloader'
import {LControlZoom, LImageOverlay, LMap, LMarker, LTileLayer} from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import PinchZoom from "vue-pinch-zoom";

var progressDialog, loadingDialog;

export default {
  components: {
    'image-preloader': imagePreloader,
    'pinch-zoom': PinchZoom,
    LMap,
    LTileLayer,
    LMarker,
    LImageOverlay,
    LControlZoom
  },
  data: function () {
    return {
      webcamData: { name: null},
      selectedWebcamId: null,
      isDataLoaded: false,
      isImagesLoaded: false,
      currentItemTime: '00:00',
      preloaderLoaded: 0,
      currentImageIndex: 1,
      wcMaxImages: 5,
      wcCurrentMaxImages: 5,
      wcNumImages: 0,
      imagesToWalk: [],
      lastUpdated: 0,
      tCheckInterval: null,
      imageUrl: 'static/shmu/img/blank.png',
      base_url: null,
      mapOptions: {
        zoomControl: false,
        zoomSnap: 0.5,
        minZoom: 1,
        maxZoom: 4,
        zoom: 2,
        crs: L.CRS.Simple

      },
      imageBounds: [[85.05,-39.375], [59.53,-180]]
    };
  },
  filters: {
    capitalize: function(s) {
      return s.charAt(0).toUpperCase() + s.slice(1)
    }
  },
  mounted() {
    const self = this;
    // otvorime hlavne menu
    this.$f7.accordion.close('.shmu-i-pocasie');
    this.$f7.accordion.open('.shmu-i-pocasie');

    if (this.$ls.get('wc_num_images') !== null) {
      this.wcMaxImages = parseInt(this.$ls.get('wc_num_images'));
    }

    this.$nextTick(() => {
      this.initMap();
    });

  },
  updated: function () {
    const self = this;
    this.$nextTick(function () {
      if (self.$f7.range.get('.wc-range')) {
        if (self.wcMaxImages != self.$f7.range.get('.wc-range').max) {
          self.$f7.range.get('.wc-range').max = this.wcMaxImages;
        }
      }


    })
  },
  destroy() {
    clearInterval(this.tCheckInterval);
  },
  watch: {
    wcMaxImages(val) {
      this.$ls.set('wc_num_images', parseInt(val));
    }
  },
  computed: {
    groupedWebcams() {
      return _.chunk(this.webcamData, 2);
    },
    imagesToPreload() {
      let finalToLoad = [];
      const self = this;

      if (self.webcamData.links.length > 0) {

          this.base_url = self.webcamData.base_url;

          let tmp = self.webcamData.links.sort((a, b) => (self.$moment(a.dt).unix() < self.$moment(b.dt).unix()) ? 1 : -1);
          let tmp3 = [];

          tmp3 = tmp.slice(0, this.wcMaxImages);

          this.wcCurrentMaxImages = tmp3.length;

          this.imagesToWalk = tmp3.sort((a, b) => (self.$moment(a.dt).unix() > self.$moment(b.dt).unix()) ? 1 : -1);
          this.imagesToWalk.forEach((v) => {
            finalToLoad.push(self.base_url + v.img);
          });

          if (finalToLoad.length > 0) {
            progressDialog = this.$f7.dialog.progress('Načítavam snímky...', 0);
          }

        return finalToLoad;
      }
    }
  },
  methods: {
    onPageInit() {
      this.selectedWebcamId = this.$f7route.params.id;
      this.pageReload(null, true);
    },
    pageReload(event, isInit) {
      const self = this;

      if (isInit || (this.$moment().unix() - this.lastUpdated) > 60) { // ak posledne stiahnutie bolo menej ako 1 min, tak nedovolime refresh

        loadingDialog = self.$f7.dialog.preloader('Načítavam...');

        Axios.get(SHMUconf.API_BASE_URL + 'meteo/getwebcams?id=' + self.selectedWebcamId, {
          crossDomain: true,
          cache: false,
        })
            .then((response) => {
              if (!response.data.error) {
                self.webcamData = response.data;
                self.isDataLoaded = true;
                self.lastUpdated = self.$moment().unix();

                self.wcNumImages = self.webcamData.links.length;

                this.imageUrl = this.getLatestWebcamImage(this.webcamData)

              } else {
                self.$f7.dialog.alert('Nepodarilo sa načítať snínky z webkamery', 'Nastala chyba');
              }

              loadingDialog.close();
              loadingDialog = null;
            }).catch((error) => {
          loadingDialog.close();
          loadingDialog = null;
          self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
        });
      }


    },


    imageLoadedOne(e) {
      progressDialog.setProgress(e.progress);
      progressDialog.setText(e.count + ' z ' + e.length);
    },
    imageLoadedAll(e) {
      progressDialog.close();
      progressDialog = null;
      this.isImagesLoaded = true;
      this.setImage(this.wcCurrentMaxImages);

    },
    imagePreloadError(e) {
      const self = this;
      if (progressDialog !== null) {
        progressDialog.close();
        progressDialog = null;
      }
      this.isImagesLoaded = true;
      self.$f7.dialog.alert('Niektoré obrázky sa nepodarilo načítať.', 'Nastala chyba');
      console.log('Nepodarilo sa nacitat: ',  e.errorImgs);
    },
    rangeChanged(val) {
        this.setImage(val);
    },
    setImage(i) {
      if (i >= this.wcCurrentMaxImages) {
        i = this.wcCurrentMaxImages;
      }
      this.currentImageIndex = i;
      let fname = '';
      let dt;
      this.imagesToWalk.forEach((v, ii) => {
        if (ii + 1 === i) {
          fname = v.img;
          dt = v.dt;
          return;
        }
      });
      if (fname !== '') {
        this.imageUrl = this.base_url + fname;
        this.currentItemTime = this.$moment(dt).format('HH:mm');
      }
    },
    maxNumChanged(event) {
      let val = event.target.value || event.target.defaultValue;
      this.wcMaxImages = val;
      this.$f7.popover.close();
    },

    getLatestWebcamImage(webcam_data) {
      const self = this;
      let url = webcam_data.base_url;

      let latest = webcam_data.links.reduce((a, b) => {
        return new self.$moment(a.dt).unix() > self.$moment(b.dt).unix() ? a : b;
      })

      if (latest) {
        return url + latest.img;
      } else {
        return 'http://www.shmu.sk/img/blank.png';
      }


    },

    getLatestWebcamDt(webcam_data) {
      const self = this;
      let latest = webcam_data.links.reduce((a, b) => {
        return new self.$moment(a.dt).unix() > self.$moment(b.dt).unix() ? a : b;
      })

      if (latest) {
        return self.$moment(latest.dt).format('DD.MM.YYYY HH:mm');
      } else {
        return '?';
      }


    },

    onPageBeforeOut() {
      const self = this;
     // console.log('onPageBeforeOut');
      // Close opened sheets on page out
        self.$f7.popover.close();
    },
    onPageBeforeRemove() {
      const self = this;
   //   console.log('onPageBeforeRemove');
      // Destroy sheet modal when page removed
      if (self.popover) self.popover.destroy();
    },

    initMap() {
      const self = this;
      this.$$('.leaflet-control-attribution a').each((i, item) => {
        self.$$(item).addClass('external')
      });

      let w = 800;
      let h = 600;
      if (this.$refs.webcamMap) {
        let map = this.$refs.webcamMap.mapObject;
        let southWest = map.unproject([0, h], map.getMaxZoom() - 1);
        let northEast = map.unproject([w, 0], map.getMaxZoom() - 1);
        self.imageBounds =  new L.LatLngBounds(southWest, northEast);
        map.setMaxBounds(self.imageBounds);
      }


    },

  }

};
</script>

<style lang="scss">

/*
.wc-image {
  max-width: 100%;
  height: auto;
}
 */


.wc-time {
  font-weight: bold;
  font-size:1.1rem;
}


.md {
  .wc-time {
    padding-top:0.4rem;
  }

  .wc-btn {
    padding-top:0.4rem;
  }

  .wc-range {
    padding-top: 1.1rem;
  }
}
.wc-toolbar {
  max-width:400px;
  width:100%;
  margin: 0px auto;
}

</style>
